import React from 'react';
import { PageHeader } from 'components';
import {
  Form,
  Col,
  Row,
  Button,
  Spin,
  Typography,
  Table,
  Descriptions,
  Select,
} from 'antd';
import styles from './style.module.scss';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import { CheckOutlined } from '@ant-design/icons';
import FileSection from './formSections/file';
import FormHelper from 'helpers/FormHelper';
import useInvoiceMonthlies from '../useInvoiceMonthlies';
import moment from 'moment';
import UIHelper from 'helpers/UIHelper';
import { ActionModal } from 'components';
import { useNavigate } from 'hooks/useNavigate';
import { useLocation } from 'react-router-dom';
import TableReports from './formSections/tableReports';
import PeriodSelection from './formSections/periodSelection';
import HolidayTable from './formSections/holidayTable';

const New = ({ isNew }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { t } = useTranslation();
  const {
    form,
    handleCreate,
    updateInProcess,
    shops,
    inactiveShops,
    loading,
    isShowedPopup,
    reportId,
    setIsShowedPopup,
    showModal,
    setShowModal,
    handleUploadExcelFile,
    handleDownloadExcel,
    tableData,
    tableHolidayData,
    handleCompanySelect,
    periodType,
  } = useInvoiceMonthlies(false);

  const onFinish = async (values) => {
    await handleCreate(values, 'stepOne');
  };

  const handleCancel = () => {
    setShowModal(false);
    setIsShowedPopup(true);
    return navigate(UIHelper.getListRoute(pathname, 1));
  };

  const onFinishFailed = (errorInfo) => {
    UIHelper.openNotificationWithIcon(
      'error',
      errorInfo.errorFields[0].errors[0],
    );
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = t('PUBBLICA FATTURATO SEMESTRALE/ANNUALE');

  const actionModalBody = <div> </div>;

  const isLoaded = shops?.[0];
  return (
    <div>
      <PageHeader title={title} />
      {!isLoaded ? (
        <div className={styles.spinLoader}>
          <Spin spinning={true}></Spin>
        </div>
      ) : (
        <div className={styles.content}>
          <Form
            form={form}
            name='basic'
            wrapperCol={{
              span: 24,
            }}
            initialValues={{
              period: moment().format('YYYY'),
              company_id: shops?.[0]?.value || null,
              file: null,
              document: null,
          
            }}
            layout={'vertical'}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete='off'
            onFieldsChange={FormHelper.resetFormsFieldErrors(form)}
          >
            {!loading && (
              <>
                <InfoSection
                  isNew={isNew}
                  shops={shops}
                  inactiveShops={inactiveShops}
                  onCompanySelect={handleCompanySelect}
                />
                <Row gutter={16}>
                  <Col offset={6} span={9}>
                    <Form.Item
                      label={t('Anno')}
                      name='period'
                      rules={[
                        { required: true, message: t('Please select a year') },
                      ]}
                    >
                      <Select>
                        {Array.from({ length: 11 }, (_, i) => {
                          const year =
                            parseInt(moment().format('YYYY')) - 10 + i;
                          return (
                            <Select.Option key={year} value={`${year}-01-01`}>
                              {year}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <PeriodSelection form={form} periodType={periodType} />

                <FileSection
                  form={form}
                  handleCreate={handleCreate}
                  handleUploadExcelFile={handleUploadExcelFile}
                  handleDownloadExcel={handleDownloadExcel}
                  id={reportId}
                />

                <TableReports data={tableData} />
                <HolidayTable data={tableHolidayData} />
              </>
            )}

            <Row gutter={24}>
              <Col span={6}>
                <Typography.Title level={3}>{t('Esempio')}</Typography.Title>
              </Col>
              <br />
              <Col offset={6} span={16}>
                <Table
                  pagination={false}
                  columns={[
                    {
                      title: t('Data'),
                      dataIndex: 'invoice_date',
                    },
                    {
                      title: t('Imponibile Netto (€)'),
                      dataIndex: 'taxable',
                    },
                    {
                      title: t('Imponibile Lordo (€)'),
                      dataIndex: 'taxable_vat',
                    },
                    {
                      title: t('N. Scontrini'),
                      dataIndex: 'receipts',
                    },
                    {
                      title: t('N. Pezzi Venuti'),
                      dataIndex: 'pieces',
                    },
                  ]}
                    dataSource={[
                    {
                      invoice_date: '01.01.23',
                      taxable: '100,00',
                      taxable_vat: '90,00',
                      receipts: 10,
                      pieces: 20,
                    },
                    {
                      invoice_date: '02.01.23',
                      taxable: '110,00',
                      taxable_vat: '95,00',
                      receipts: 11,
                      pieces: 22,
                    },
                    {
                      invoice_date: '03.01.23',
                      taxable: '120,00',
                      taxable_vat: '100,00',
                      receipts: 12,
                      pieces: 24,
                    },
                    {
                      invoice_date: '04.01.23',
                      taxable: '130,00',
                      taxable_vat: '105,00',
                      receipts: 13,
                      pieces: 26,
                    },
                    {
                      invoice_date: '05.01.23',
                      taxable: '140,00',
                      taxable_vat: '110,00',
                      receipts: 14,
                      pieces: 28,
                    },
                    {
                      invoice_date: '06.01.23',
                      taxable: '150,00',
                      taxable_vat: '115,00',
                      receipts: 15,
                      pieces: 30,
                    },
                    {
                      invoice_date: '07.01.23',
                      taxable: '160,00',
                      taxable_vat: '120,00',
                      receipts: 16,
                      pieces: 32,
                    },
                    {
                      invoice_date: '08.01.23',
                      taxable: '170,00',
                      taxable_vat: '125,00',
                      receipts: 17,
                      pieces: 34,
                    },
                  ]}
                />
              </Col>
            </Row>
            <Row>
              <Col offset={17} span={6} style={{ marginTop: '20px',marginBottom: '20px' }}>
                <a
                  style={{
                    marginTop: '20px',
                    marginBottom: '20px',
                    textAlign: 'center',
               
              }}
              id='download-file'
              target='_blank'
              rel='noopener noreferrer'
              href={'https://dev.arcusnet.it/invoices_year.xlsx'}
            >
              {t('Scarica un file di esempio')}
                </a>
              </Col>
            </Row>
          </Form>
          <Row gutter={16}>
            <Col>
            <Typography style={{ marginTop:'20px',marginBottom:'15px',fontWeight:'bold' }}>
            ATTENZIONE : I DATI DI FATTURATO SEMESTRALE/ANNUALE ANDRANNO A SOVRASCRIVERE I FATTURATI CARICATI PRECEDENTEMENTE
            </Typography>
              <Button
                onClick={onClickSave}
                width={'150px'}
                big
                loading={updateInProcess}
                icon={<CheckOutlined />}
                disabled={!form.validateFields}
              >
                {t('Invia')}
              </Button>
            </Col>
            {isShowedPopup && (
              <ActionModal
                // loading={loading}
                show={showModal}
                title={t('dati_Veranno')}
                description={''}
                yesBtnText={t('Invia')}
                noBtnText={t('No, lascia.')}
                onClickOk={() => handleCreate({}, 'stepTwo')}
                onCancel={handleCancel}
                type={'info'}
              >
                {actionModalBody}
              </ActionModal>
            )}
          </Row>
        </div>
      )}
    </div>
  );
};

export default New;
